import styled, { css } from "styled-components";
import breakpoint from "../../../utils/breakpoint";
import getBorderRadius from "../../../utils/getBorderRadius";
import getBoxShadow from "../../../utils/getBoxShadow";
import getColor from "../../../utils/getColor";
import space from "../../../utils/space";

// eslint-disable-next-line import/prefer-default-export
export var Wrapper = styled.div.withConfig({
  componentId: "sc-dvrvke-0"
})(function (_ref) {
  var $hasDarkMode = _ref.$hasDarkMode,
    theme = _ref.theme;
  return css(["display:inline-grid;position:relative;grid-auto-columns:1fr;grid-auto-flow:column;gap:", ";align-items:center;border-radius:", ";background-color:", ";box-shadow:", ";min-height:", ";padding:", ";", "{gap:", ";}"], space(2), getBorderRadius(theme, "xlarge"), $hasDarkMode ? getColor(theme, "white", "default", 0.08) : getColor(theme, "backgroundLight"), getBoxShadow(theme, "tiny"), space(9), space(1), breakpoint("large"), space(4));
});